import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TokenGuardService } from 'src/app/guards/token-guard.service';
import { AuthWrapperComponent } from './auth-wrapper/auth-wrapper.component';

const routes: Routes = [
  {
    path: 'login',
    canActivate: [TokenGuardService],
    component: AuthWrapperComponent,

  },
  {
    path: 'signup',
    component: AuthWrapperComponent,

  },
  {
    path: 'forgotPassword',
    canActivate: [TokenGuardService],
    component: AuthWrapperComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
